exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".barcodes-top {\r\n  margin-top: 20px;\r\n}\r\n\r\n.barcodes-right {\r\n  margin-right: 85px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// c:/Projects/CCLibrary/Client/src/app/print-barcode/print-barcode.component.css
// module id = ../../../../../src/app/print-barcode/print-barcode.component.css
// module chunks = 1